'use client';

import { ReactNode } from 'react';

import { useScrollFade } from '@/lib/hooks/useScrollFade';
import { cn } from 'tailwind-variants';

import { scrollableTableWrapperVariants } from './ScrollableTableWrapper.styles';
import { useGlobalLabels } from '@/context/GlobalLabelContext';

export type ScrollableTableWrapperProps = {
  children: ReactNode;
  /** Hint shown when horizontal overflow is available */
  hintText?: string;
  className?: string;
  scrollClassName?: string;
  hintClassName?: string;
};

export const ScrollableTableWrapper = ({
  children,
  hintText,
  className,
  scrollClassName,
  hintClassName,
}: ScrollableTableWrapperProps) => {
  const [scrollRef, fade] = useScrollFade<HTMLDivElement>();
  const { wrapper, hint, hintInner, scrollContainer, fadeStart, fadeEnd } =
    scrollableTableWrapperVariants();
  const { globalLabels } = useGlobalLabels();

  const isScrollable = fade.start || fade.end;

  return (
    <> {isScrollable && (
      <p className={cn(hint(), hintClassName)} aria-hidden="true">
        <span className={hintInner()}>
          {fade.start && <i className="fa-duotone fa-light fa-chevrons-left" />}
          {hintText || globalLabels.scroll_to_see_more_label}
          {fade.end && <i className="fa-duotone fa-light fa-chevrons-right" />}
        </span>
      </p>
    )}
      <div className={cn(wrapper(), className)}>
        <div ref={scrollRef} className={cn(scrollContainer(), scrollClassName)}>
          {children}
        </div>
        {fade.start && <div className={fadeStart()} aria-hidden="true" />}
        {fade.end && <div className={fadeEnd()} aria-hidden="true" />}
      </div></>
  );
};
